import { render, staticRenderFns } from "./ve-comunidad.vue?vue&type=template&id=ddcd0094"
import script from "./ve-comunidad.vue?vue&type=script&lang=js"
export * from "./ve-comunidad.vue?vue&type=script&lang=js"
import style0 from "./ve-comunidad.vue?vue&type=style&index=0&id=ddcd0094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports